/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_SelectorInputs */

const sv_language_selector = /** @type {(inputs: Language_SelectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Språkväljare`)
};

const en_language_selector = /** @type {(inputs: Language_SelectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language selector`)
};

/**
* | output |
* | --- |
* | "Language selector" |
*
* @param {Language_SelectorInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const language_selector = /** @type {((inputs?: Language_SelectorInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_SelectorInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_language_selector(inputs)
	return en_language_selector(inputs)
});